export const profile = {
  id: '887800156380434433',
  username: 'relevantfeed',
  displayName: 'Relevant',
  emails: [{ value: 'relevantfeed@relevantfeed.com' }],
  photos: [
    {
      value:
        'https://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    },
  ],
  provider: 'twitter',
  _json: {
    id: 887800156380434400,
    id_str: '887800156380434433',
    name: 'Relevant',
    screen_name: 'relevantfeed',
    entities: {},
    description: 'Curated by communities, not clicks. https://t.co/J6Qy3MreB5',
    url: 'https://t.co/V4yLVQukek',
    protected: false,
    followers_count: 545,
    friends_count: 97,
    listed_count: 12,
    created_at: 'Wed Jul 19 22:23:46 +0000 2017',
    favourites_count: 206,
    utc_offset: null,
    time_zone: null,
    geo_enabled: true,
    verified: false,
    statuses_count: 71,
    lang: 'en',
    contributors_enabled: false,
    profile_background_color: '000000',
    profile_background_image_url: 'http://abs.twimg.com/images/themes/theme1/bg.png',
    profile_background_image_url_https:
      'https://abs.twimg.com/images/themes/theme1/bg.png',
    profile_background_tile: false,
    profile_image_url:
      'http://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    profile_image_url_https:
      'https://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    profile_banner_url:
      'https://pbs.twimg.com/profile_banners/887800156380434433/1531854405',
    profile_link_color: 'ABB8C2',
    profile_sidebar_border_color: '000000',
    profile_sidebar_fill_color: '000000',
    profile_text_color: '000000',
    profile_use_background_image: false,
    has_extended_profile: false,
    default_profile: false,
    default_profile_image: false,
    email: 'relevantfeed@relevantfeed.com',
  },
  _accessLevel: 'read',
};

export const profileNoEmail = {
  id: '8878001563804344334',
  username: 'relevantfeedNoEmail',
  displayName: 'Relevant',
  photos: [
    {
      value:
        'https://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    },
  ],
  provider: 'twitter',
  _json: {
    id: 887800156380434400,
    id_str: '887800156380434434',
    name: 'Relevant',
    screen_name: 'relevantfeed1',
    entities: {},
    description: 'Curated by communities, not clicks. https://t.co/J6Qy3MreB5',
    url: 'https://t.co/V4yLVQukek',
    protected: false,
    followers_count: 545,
    friends_count: 97,
    listed_count: 12,
    created_at: 'Wed Jul 19 22:23:46 +0000 2017',
    favourites_count: 206,
    utc_offset: null,
    time_zone: null,
    geo_enabled: true,
    verified: false,
    statuses_count: 71,
    lang: 'en',
    contributors_enabled: false,
    profile_background_color: '000000',
    profile_background_image_url: 'http://abs.twimg.com/images/themes/theme1/bg.png',
    profile_background_image_url_https:
      'https://abs.twimg.com/images/themes/theme1/bg.png',
    profile_background_tile: false,
    profile_image_url:
      'http://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    profile_image_url_https:
      'https://pbs.twimg.com/profile_images/1091395606143225856/qg9O2hHp_normal.jpg',
    profile_banner_url:
      'https://pbs.twimg.com/profile_banners/887800156380434433/1531854405',
    profile_link_color: 'ABB8C2',
    profile_sidebar_border_color: '000000',
    profile_sidebar_fill_color: '000000',
    profile_text_color: '000000',
    profile_use_background_image: false,
    has_extended_profile: false,
    default_profile: false,
    default_profile_image: false,
    email: '',
  },
  _accessLevel: 'read',
};
